module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he piercing screech of brakes with its accompanying teeth-jarring squeal of tires had Georges Armand tensing, bracing for what he thought was the inevitable impact.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His breath stopped in his lungs.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The unpredictability of life was something that never ceased to amaze him. Given his background and his present vocation, the opposite should have been true.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges Armand was the second son of the colorful, exceedingly flamboyant Lily Moreau, a living legend in the art community, both for her talent and her lifestyle. To say that his formative years had been unorthodox was like referring to the Civil War as a slight misunderstanding between two sections of the country. It was true, but a vast understatement. With his mother flittering in and out of his life like warm rays of sporadic sunshine, the one stable thing Georges could always count on was his brother, Philippe Zabelle. The rest of his world seemed to be in constant flux.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fourth-year medical resident at Blair Memorial, his choice of career, general internal surgeon, also placed him in that same quixotic mix. It was never so clear to him as during his present stint in the hospital’s emergency room. One moment, life was quiet, progressing on an even, uneventful keel. Then within the next rotation of the second hand, all hell was breaking loose.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so it was tonight.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After putting in a double shift at the hospital, rather than electing to sleep for the hours that he was off duty to do his best to recharge his very spent batteries, Georges decided to go out. He was his late father’s son and loved to party.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Handsome, with magnetic blue eyes, hair the color of the underside of midnight and a smile that pulled in all living females within a twelve-mile radius, Georges had not experienced a lack of female companionship since the year he turned ten. From the moment he first opened his eyes twenty-nine years ago, he had been, and continued to be, a lover of women. All women. Tall ones, short ones, rounded, thin, old, young, it didn’t matter. To Georges, every breathing woman was beautiful in her own way and each merited his attention.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a short time.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of the three brothers, Philippe, three years his senior, and Alain Dulac, three years his junior, Georges was the most like Lily, who, by her own admission had said more than once that she had never met a man she didn’t like—at least for a short time.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tonight he was off to see Diana, a woman he’d met in the E.R. a month ago when she came in complaining of acute gastrointestinal distress. It turned out to be a case of bad sushi. He prescribed medication to help her along and discharged her. And once she wasn’t his patient, he dated her. Brunette, brown-eyed, Diana was vivacious, outgoing and said she was definitely not interested in any strings to their relationship. She was the kind of woman you could have a good time with and not have to worry that she was misreading the signs and mentally writing out wedding invitations. In other words, she was perfect.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he drove his bright red sports car—a gift from Lily on his graduation from medical school—Georges was mentally mapping out the evening that lay ahead. A little dinner, a little dancing and a great deal of romance.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But all that changed in an instant.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The horrifying sound behind him had Georges swerving to the right. The nose of his vehicle climbed up against the hillside embankment. The maneuver was just in time for him to avoid being hit by the vintage blue sedan behind him. The latter was not so lucky. The black Mercedes behind the sedan slammed right into it.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His heart pounding against his rib cage, Georges looked into his rearview mirror. He saw the dark blue sedan spinning around helplessly, like a badly battered pinwheel in the center of a gale. Out of his car in an instant, Georges ran toward the car to see if he could help the passengers.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t the doctor in him that made Georges bolt out of his barely stilled sports car; it was the Good Samaritan, the instinct that had initially been instilled, fostered and nurtured by his mother. But it was predominantly Philippe who’d taught him that standing on the sidelines, watching, when you could be in the midst of the turmoil, helping, was never a truly viable option. Philippe believed in commitment, and Georges believed in Philippe.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He attributed all his good traits to his older brother, his looks to his mother and his money, of which there was more than a considerable amount, to his late father, Lily Moreau’s second husband, Andre. Andre Armand was a self-made millionaire who owed his fortune to the production of a seductive yet affordable perfume. A scent, despite all her money, that Lily still wore.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The instant Georges opened the driver’s-side door and was out of his vehicle, he found himself having to flatten his back against it to get out of harm’s way. The Mercedes that had rammed into the sedan and had initiated this lethal game of metal tag now whizzed erratically by him. Had he not jumped back, Georges was certain that he would have wound up being the black Mercedes’ new hood ornament. Or, if not that, then permanently sealed to the vehicle’s shiny grill.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The figure of a dark-haired, middle-aged man registered at the same time that the vehicle zoomed by him. Blessed with incredibly sharp vision and presence of mind, Georges focused on the license plate even as the vehicle disappeared around one of the many curves that typified Southern California’s winding Pacific Coast Highway.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The entire incident took place in less than a heartbeat.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges was running toward the blue sedan, which had finally stopped spinning. Its front end was now pointed in the opposite direction of the flow of traffic.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver’s side was mashed against the hillside.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now that the brakes were no longer screeching and the tires no longer squealing, Georges became aware of another noise, one that had been blocked out by the first two. Screams. The woman within the sedan, in the front passenger seat, was screaming.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as he reached the passenger side, Georges saw thin orange-and-yellow tongues of fire began to lick the front of the hood.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From what he could tell, there was only one other occupant in the car, the driver. The gray-haired man was slumped over the steering wheel. Georges tried to open the passenger door, but the impact from the careening Mercedes had wedged the door shut.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Desperate, afraid that any second the engine might explode, Georges tried to break the window with his elbow, swinging as hard as he could. The impact reverberated up and down his arm and shot into his chest, but the window remained a solid barrier.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman inside the car looked at him, their eyes meeting as shock pressed itself into her young features. Frantically, she tried to open the window on her side, working the buttons on the armrest. It was useless. There was no power fueling the buttons. The window remained in place, sealing in both her and the unconscious driver.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He needed something solid, such as a tire iron, to break the glass, but there wasn’t enough time to run back to his car to get one. Georges knew that the sedan could blow up at any moment.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Pacific Coast Highway wove its way along the coast with the ocean on one side, a sprawling hillside pockmarked with exceedingly expensive real estate on the other. Searching the ground for something heavy to use, Georges spotted a good-sized rock and quickly picked it up. Hurrying back to the passenger door, he knocked on the window until the woman looked at him again.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Duck your head,” he shouted at her, lifting the rock.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman did as she was told, turning her body so that she was shielding the man in the driver’s seat. Pulling back his arm, Georges threw the rock as hard as he could at the window. The surface of the glass cracked and splintered in half a dozen places. Wrapping his jacket about his right hand, he punched through the shattered glass and cleared away as much as he could.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“C’mon,” he ordered the woman, “You have to get out of there.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde shook her head emphatically. Her arms were still around the old man. “I can’t leave him,” she cried.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges looked from her to the driver. He was old, too old, he judged, to be her husband or even her father. There was blood on the man’s forehead and he seemed to be unconscious, but breathing. Georges couldn’t be sure of the latter.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was sure that if he spent time arguing with the blonde, they could all suffer the consequences. Leaning in, Georges grabbed the woman by her waist. Surprised, she began to resist.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“First you, then him,” Georges told her firmly. Before she could say anything, he was pulling her through the opening he’d created. He felt the jagged edges scratch at his skin. The blonde weighed next to nothing, even as she struggled against him.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My grandfather!” she cried as Georges deposited her on the ground.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He examined the other side of the car. It was pressed against the hillside, leaving no room for him. No way could he snake his way in and open the door on that side to get the man out. Without stopping to take into consideration that the car could blow up at any moment, Georges relied on the luck that had seen him through most of his life and crawled in through the window.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old man’s seat belt was still on. Georges hit the release button and pulled the man over toward his side. Moving as quickly as he could, he angled his body so that they could switch places. He needed the old man next to the opened window.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde realized what he was doing. “Push him through,” she urged. “I can hold him up.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had his doubts about that. The blonde didn’t look as if she could hold a twenty-pound sack of grain without stumbling beneath its weight. But he had no other option. Putting his shoulder against the man’s lower torso, Georges pushed the old man’s upper body through the opening.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To his surprise, the woman slipped her arms beneath the old man’s arms and moved backward, pulling the deadweight as he pushed him out. He heard her groan and utter a noise that sounded very much like a battle cry.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next moment, between the two of them, they’d managed to get the old man out of the vehicle.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The second the unconscious driver was clear of the door, Georges dove out, headfirst, tucking down and into his torso just before he hit the ground so that he rolled. In an instant, he was back up on his feet again. Quickly shoving his shoulder down beneath the old man’s, he wrapped his arm around the man’s waist.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Run!” he shouted at the blonde.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instead of dashing before him, the woman mirrored his movements, getting her shoulder beneath the old man’s other shoulder so that both he and the old man could get away from the fiery vehicle faster.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges thought he heard the old man mumble, “Leave me,” but he didn’t know if he’d imagined it or not. In any case, he wasn’t about to abandon the man, not after all the trouble he’d just gone through to rescue the driver.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They barely made it back to the front of his sports car before the blue sedan burst into flames.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges threw his body over the old man and the blonde just as their car exploded. After several moments had elapsed, he pulled back, suddenly aware of another problem. On his knees, Georges felt the man’s throat and then his chest for a pulse. There was none.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde stared, wide-eyed, barely holding fear at bay. “What is it?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In response, Georges threaded his hands together over the man’s chest and began to administer CPR. He hardly glanced in her direction, concentrating on only one thing: getting the man’s heart to beat again. “I think he’s had a heart attack.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” The word escaped her lips like a shell being fired, aimed not at Georges as a denial of his statement but at the old man lying on the ground. “No! Grandpa, do you hear me?” She scrambled closer to the man, moving in on his other side. “No, you can’t do this,” she told him urgently. “You can’t have a heart attack.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was absolutely no response from the driver.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think he’s listening to you,” Georges told her in between beats.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mentally, he counted off compressions, then tilted the man’s head back. Pinching his nose, Georges leaned over the man’s mouth to blow his breath into it. Once, twice, a third time, before returning to compressions. The man still wasn’t responding. Georges didn’t allow himself to think about anything except the success of his efforts. Everything else, including the blonde’s voice, became a distant blur.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In my left coat pocket,” he told her as he resumed compressions for a third time, “I’ve got a cell phone.” The moment he said it, she galvanized into action, reaching her long, slender fingers into his pocket. He could feel them as they slid in.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he fought death for possession of the old man’s life, it struck him that this was one hell of a way to meet a woman. Because even in the midst of the ongoing turmoil, as he struggled to bring the driver back around, it did not escape Georges that she was one of the most attractive women he had ever seen.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Got it!” she declared breathlessly, pulling the cell phone out of his pocket. Rocking back on her knees, she began to press the three numbers that popped into everyone’s mind during an emergency.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nine-one-one would generate an appearance of an ambulance driven by EMTs. Given where they were, the paramedics could take them to one of two hospitals, most likely County General since it had a contract with the company that most often appeared on the scene. However, Blair Memorial was just as close as County General and it was the better of the two hospitals. It was also the hospital where he put in his hours.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t call 911,” he told her, then rattled off the number she should call before he breathed into her grandfather’s mouth.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde looked at him, confused. “Why should I call that number?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because that number will get you the ambulance attendants from Blair Memorial hospital and they have the better emergency room staff,” he told her with no hesitation. He spared her a quick glance. “You want the best for him, don’t you?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t bother answering. As far as she was concerned, that was a rhetorical question. So instead, she pressed the buttons on the keypad. Two rings into the call, the receiver was being picked up.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Blair Memorial, E.R.,” a calm, soothing voice said.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Visibly struggling to remain coherent, the blonde clutched the cell phone with both hands as she gave the man on the other end of the line all the necessary details. Finished, she followed up the information with one more instruction.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please hurry.” With that, she let out a shaky breath and closed the cell phone again.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think that’s a given,” Georges told her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes darted back toward the man administering CPR to her larger-than-life grandfather.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Breathe, damn it, Grandpa, breathe! I’m not ready to live in a world without you in it yet. You promised me that you’d never leave me alone. Don’t break your promise, Grandpa. Don’t break your promise")]), _vm._v(".")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking herself free of the terror that threatened to swallow her up whole, she forced herself to look at the man kneeling beside her grandfather. The savior who had come to their rescue.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Replaying his last words, she blinked, trying to focus. “What is?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That they’ll hurry.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was sitting back on his heels. A fresh wave of terror drenched her, leaving her shivering. “Why did you stop giving him CPR?” she demanded, an audible tremor in her voice as it rose. The words rushed out of her mouth. “Why aren’t you trying to get his heart going?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He curved his mouth into a slight smile. Triumph at this point, he knew, could be tenuous and very short-lived. By no means was the man on the ground out of the woods. “Because it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" going,” he told her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes darted back to her grandfather, searching for proof. Staring at his chest. Was that movement? “On its own?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges nodded. “On its own.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tears suddenly formed in her eyes. He became aware of them half a beat before the blonde threw her arms around his neck.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Half a beat before she kissed him.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hard.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like the oncoming tide, she pulled back as quickly as she had rushed forward. Georges realized that he had tasted not only something sweet when her lips had pressed against his, but something moist, as well. Tears. He’d tasted her tears on her lips. They must have fallen there just as she’d impetuously made contact with his.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They tasted salty and yet, somehow they were oddly sweet, as well.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” she cried breathlessly. “Thank you.” And then, just like that, her complete attention was focused back on her grandfather. She took the old man’s hand in both of hers and held it next to her cheek. With effort, she controlled the tremor in her voice. “Now you just hang on, Grandpa, you hear me? Help’s on the way.” For a split second, her eyes shifted back to the man who had saved them both.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges felt himself getting lost in her smile as she murmured, “Some of it’s already here.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Forcing himself to look back at his patient, Georges thought he saw the old man’s eyelids flutter, struggling unsuccessfully to open. He took the man’s other hand in his and once again felt for a pulse. He found it, albeit a weak one. Mentally, Georges counted off the beats.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde looked at him quizzically, obviously waiting for positive reaffirmation.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s still a little reedy,” he told her. “When they get him to the hospital, I think your grandfather should stay overnight for observation. They’ll take some films, do an angiogram.” Georges looked at the man’s face. It was remarkably unlined, but he would still place him somewhere in his late sixties, possibly early seventies. Other than the gash on his forehead and the episode he’d just experienced, the man seemed to be in rather good condition. But appearances could be deceiving. “Does your grandfather have any medical conditions that you’re aware of?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde laced her fingers through her grandfather’s hand, as if her mere presence could ward off any serious complications. “I’m aware of everything about my grandfather,” she told him. There was no defensiveness in her voice, it was simply the way things were. She took an active interest in this man who was very much the center of her world. “He has a minor heart condition—angina,” she specified. “And he’s also diabetic. Other than that, he’s always been healthy.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georges focused only on what he considered to be liabilities. “Those are complicating factors.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde pushed back a strand of hair that had fallen into her face. She continued holding her grandfather’s hand. “Are you a doctor?”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled. “I’m a fourth-year resident.” He thought of John LaSalle, the attending physician that he was currently working under. LaSalle regarded residents as lower life forms only slightly higher than lab rats. “In some eyes, that makes me an ‘almost’ doctor.”")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blonde looked back at her grandfather and, for a moment, watched the way the man’s chest rose and fell in grateful silence. She was aware that she might not be watching that if it hadn’t been for the efforts of the man beside her.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s nothing ‘almost’ about you,” she replied softly.")]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took Georges a second to realize that those were not bells he was hearing in his head but the sound of an approaching siren.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e92a914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tamingtheplayboy_ch01.vue
// module id = 66
// module chunks = 0